module.exports = __webpack_public_path__ + "img/pdf2.2.7d4e8912.svg";